<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ApplyLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '达标申报'
            },
            {
              key: '2',
              title: '达标人员管理'
            }, 
          ],
          active: () => {
            switch (this.$route.path) {
              case '/huiyi/ShengDabiaoManage':
                return '1'
              case '/huiyi/ShengDabiaoList':
                return '2' 
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/huiyi/ShengDabiaoManage')
                break
              case '2':
                this.$router.push('/huiyi/ShengDabiaoList')
                break 
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>